import React, { ReactElement, useState } from 'react'
import TabTitle from './TabTitle'

type Props = {
  children: ReactElement[]
}

const Tabs: React.FC<Props> = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <div>
      <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
        {children.map((item, index) => (
          <TabTitle
            key={index}
            active={index === selectedTab}
            title={item.props.title}
            index={index}
            setSelectedTab={setSelectedTab}
          />
        ))}
      </ul>
      <div className="card mt-5">{children[selectedTab]}</div>
    </div>
  )
}

export default Tabs
